module.exports = __webpack_public_path__ + "static/deliver-d110830376872c15392f71482b62f5d0.svg";